module.exports = ".dropdown-menu {\n  left: -133px !important;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main-settings/customer-banks/customer-banks.component.css
// module id = ./src/app/main-settings/customer-banks/customer-banks.component.css
// module chunks = main